import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["title"]

import { Ref, computed, ref } from 'vue'
import { RouteLocationRaw } from 'vue-router'

import BaseLink from '@/components_new/BaseLink.vue'
import Icon, { IconNameType } from '@/components_new/Icon/Icon.vue'
import Link from '@/components_new/Link.vue'
import { useScroll } from '@/composables/use-scroll'
import { useTr } from '@/composables/use-tr'
import { AvailableLocale } from '@/i18n/helpers'
import { ShortCategory, useGeneralData } from '@/query/use-general-data'
import { ROUTE_NAMES } from '@/router/constants'
import {
    DEVELOPERS_LANDPAGE_PATH,
    NAVIGATION_ALL_GAMES_LINKS,
    NavLink,
    PARTNERS_LANDPAGE_PATH,
    SOCIAL_LINKS,
} from '@/router/navigation-constants'

import Copyright from '../Copyright.vue'
import LocaleSwitchersList from '../LocaleSwitchers/LocaleSwitchersList.vue'
import SeoOnly from '../SeoOnly.vue'
import Typography from '../Typography.vue'

interface LeftSideProps {
    languageLinks?: Record<AvailableLocale, string>
}

type Category =
    | ShortCategory
    | {
          id: IconNameType
          title: string
          location: RouteLocationRaw
      }


export default /*@__PURE__*/_defineComponent({
  __name: 'LeftSide',
  props: {
    languageLinks: {}
  },
  setup(__props: any) {

const props = __props

const scrollStore = useScroll()
const { topActive, bottomActive } = scrollStore

const scrollerRef = ref<HTMLElement | null>(null)

const handleMouseLeave = (event: MouseEvent | FocusEvent) => {
    const currentTarget = event.currentTarget as Node
    const relatedTarget = event.relatedTarget as Node | null

    if (relatedTarget !== currentTarget && !currentTarget?.contains(relatedTarget)) {
        setTimeout(() => {
            if (scrollerRef.value) {
                // Reset scroll position after a short delay to allow for smooth scrolling
                scrollerRef.value.scrollTo({ top: 0, behavior: 'smooth' })
            }
        }, 120)
    }
}

const tr = useTr()
const { mainData } = useGeneralData()
const menuCategoriesList = computed(() => mainData.value.menuCategoriesList || [])
const allGamesNavigation = computed(() => Object.values(NAVIGATION_ALL_GAMES_LINKS(tr)))

const preparedCategoriesList: Ref<Category[]> = computed(() => {
    return [
        { id: 'heart', location: { name: ROUTE_NAMES.MY_GAMES }, title: tr('myGames.title') },
        ...menuCategoriesList.value,
        ...allGamesNavigation.value.map((item) => ({
            id: item.icon,
            title: item.title,
            location: item.to,
        })),
    ]
})

const pagesLinks = computed<(NavLink & { icon: IconNameType })[]>(() => [
    {
        title: tr('navigation.shop'),
        to: { name: ROUTE_NAMES.SHOP },
        icon: 'present',
        dataInterfaceTarget: 'shop-link',
    },

    {
        title: tr('navigation.developers'),
        externalTo: DEVELOPERS_LANDPAGE_PATH,
        icon: 'bridge',
        target: '_blank',
    },
    {
        title: tr('navigation.publishers'),
        externalTo: PARTNERS_LANDPAGE_PATH,
        icon: 'two_fingers',
        target: '_blank',
    },
    {
        title: tr('navigation.contact_us'),
        icon: 'smile',
        to: { name: ROUTE_NAMES.CONTACTS },
    },
    {
        title: tr('navigation.terms_of_use'),
        icon: 'flag',
        to: { name: ROUTE_NAMES.TERMS_OF_USE },
    },
])

const socialLinks = computed<(NavLink & { icon: IconNameType })[]>(() => SOCIAL_LINKS(tr))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.sidebar),
    "data-interface-section": "sidebar",
    tabindex: "0",
    onFocusout: handleMouseLeave,
    onMouseleave: handleMouseLeave
  }, [
    _createVNode(Link, {
      to: { name: _unref(ROUTE_NAMES).MAIN },
      "data-interface-target": "navigation-link",
      class: _normalizeClass([_ctx.$style.icon_wrapper, _ctx.$style.hovered]),
      color: "rainbow"
    }, {
      default: _withCtx(() => [
        _createVNode(Icon, {
          name: "fennek",
          class: _normalizeClass(_ctx.$style.icon)
        }, null, 8, ["class"])
      ]),
      _: 1
    }, 8, ["to", "class"]),
    _createVNode(Link, {
      to: { name: _unref(ROUTE_NAMES).MAIN },
      "data-interface-target": "navigation-link",
      class: _normalizeClass([_ctx.$style.icon_wrapper, _ctx.$style.non_hovered]),
      hoverAnimation: "rainbow"
    }, {
      default: _withCtx(() => [
        _createVNode(Icon, {
          name: "fennek",
          class: _normalizeClass(_ctx.$style.icon)
        }, null, 8, ["class"])
      ]),
      _: 1
    }, 8, ["to", "class"]),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.wrapper)
    }, [
      _createElementVNode("div", {
        ref_key: "scrollerRef",
        ref: scrollerRef,
        class: _normalizeClass(_ctx.$style.scroller),
        onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(scrollStore).onVerticalScroll && _unref(scrollStore).onVerticalScroll(...args)))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(preparedCategoriesList.value, (item) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: item.id
          }, [
            (item.location)
              ? (_openBlock(), _createBlock(BaseLink, {
                  key: 0,
                  to: item.location,
                  "data-interface-target": "category",
                  title: item.title,
                  class: _normalizeClass(_ctx.$style.item)
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass(_ctx.$style.item_content)
                    }, [
                      _createVNode(Icon, {
                        name: item.id,
                        alt: item.title,
                        class: _normalizeClass(_ctx.$style.item_icon)
                      }, null, 8, ["name", "alt", "class"]),
                      _createVNode(Typography, {
                        type: "label",
                        size: "m",
                        accent: "",
                        class: _normalizeClass(_ctx.$style.item_content_title),
                        responsive: false
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["class"])
                    ], 2)
                  ]),
                  _: 2
                }, 1032, ["to", "title", "class"]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128)),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style.rest)
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style.sep_section)
          }, null, 2),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pagesLinks.value, (item) => {
            return (_openBlock(), _createBlock(BaseLink, {
              key: item.title,
              title: item.title,
              class: _normalizeClass(_ctx.$style.item),
              tabindex: "-1",
              to: item.to,
              externalTo: item.externalTo,
              target: item.target,
              "data-interface-target": "navigation-link"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.$style.item_content)
                }, [
                  _createVNode(SeoOnly, { ariaHidden: "" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.title), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(Icon, {
                    name: item.icon,
                    alt: item.title,
                    class: _normalizeClass(_ctx.$style.item_icon)
                  }, null, 8, ["name", "alt", "class"]),
                  _createVNode(Typography, {
                    type: "label",
                    size: "m",
                    accent: "",
                    class: _normalizeClass(_ctx.$style.item_content_title),
                    responsive: false
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["class"])
                ], 2)
              ]),
              _: 2
            }, 1032, ["title", "class", "to", "externalTo", "target"]))
          }), 128)),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style.sep_section)
          }, null, 2),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style.social_links)
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(socialLinks.value, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id,
                title: item.title,
                class: _normalizeClass(_ctx.$style.item)
              }, [
                _createVNode(BaseLink, {
                  externalTo: item.externalTo,
                  target: item.target,
                  "data-interface-target": "navigation-social-link",
                  class: _normalizeClass(_ctx.$style.item_content)
                }, {
                  default: _withCtx(() => [
                    _createVNode(Icon, {
                      name: item.icon,
                      alt: item.title,
                      class: _normalizeClass(_ctx.$style.item_icon)
                    }, null, 8, ["name", "alt", "class"]),
                    _createVNode(SeoOnly, { ariaHidden: "" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.title), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["externalTo", "target", "class"])
              ], 10, _hoisted_1))
            }), 128))
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style.sep_section)
          }, null, 2),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style.lang_section)
          }, [
            _createVNode(LocaleSwitchersList, {
              languageLinks: props.languageLinks
            }, null, 8, ["languageLinks"])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style.sep_section)
          }, null, 2),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style.copyright_section)
          }, [
            _createVNode(Copyright)
          ], 2)
        ], 2)
      ], 34),
      _createElementVNode("div", {
        class: _normalizeClass([_ctx.$style.shadow, _ctx.$style.shadow_top, { [_ctx.$style.visible]: _unref(topActive) }])
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass([_ctx.$style.shadow, _ctx.$style.shadow_bottom, { [_ctx.$style.visible]: _unref(bottomActive) }])
      }, null, 2)
    ], 2)
  ], 34))
}
}

})